import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  addressLine1: '',
  addressLine2: '',
  addressLine3: ''
};

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setAddressLine1(state, action) {
      state.addressLine1 = action.payload;
    },
    setAddressLine2(state, action) {
      state.addressLine2 = action.payload;
    },
    setAddressLine3(state, action) {
      state.addressLine3 = action.payload;
    },
    clearAddress(state) {
      state.addressLine1 = '';
      state.addressLine2 = '';
      state.addressLine3 = '';
    }
  }
});

export const {
  setAddressLine1,
  setAddressLine2,
  setAddressLine3,
  clearAddress
} = addressSlice.actions;
export const selectAddressLine1 = state => state.address.addressLine1;
export const selectAddressLine2 = state => state.address.addressLine2;
export const selectAddressLine3 = state => state.address.addressLine3;

export default addressSlice.reducer;
